import { render, staticRenderFns } from "./add_account.vue?vue&type=template&id=abb37b2e&scoped=true"
import script from "./add_account.vue?vue&type=script&lang=js"
export * from "./add_account.vue?vue&type=script&lang=js"
import style0 from "./add_account.vue?vue&type=style&index=0&id=abb37b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb37b2e",
  null
  
)

export default component.exports